import { Component } from '@angular/core';
import { PmdAccordionItem } from './accordion-group.component';

@Component({
  selector: 'pmd-accordion-item-header',
  exportAs: 'pmdAccordionItemHeader',
  templateUrl: './pmd-accordion-item-header.html',
  host: {
    class: 'accordion-header pmd-accordion-header',
    "(click)": "toggleOpen($event)"
  }
})

export class PmdAccordionItemHeader {
  constructor(private sbItem: PmdAccordionItem) {}  
  toggleOpen(event: Event): any {
    if (!this.sbItem.disabled) {
      this.sbItem.isOpen = !this.sbItem.isOpen;
    }
  }
}
